define.alias("shared/components/shared/ui/report/industry-comparison", "media/components/shared/ui/report/industry-comparison");